module.exports = __webpack_public_path__ + "img/139.3721a096.jpg";